export default (response) => response?.data?.length ?? 0;
